// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wa_a bhc_b","TwoDimsListFeature__item":"wa_b bhc_wb","TwoDimsListFeature__item__text":"wa_c bhc_vr"};